import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AssinaturaDocumento } from 'src/app/pages/call-center/pages/projects/models/assinatura-documento';
import { Signatario } from 'src/app/pages/call-center/pages/projects/models/signatario';
import { StatusDocumentoAssinatura } from 'src/app/pages/call-center/pages/projects/models/status-documento';
import { AssinarDocumentoService } from 'src/app/pages/call-center/pages/projects/services/assinar-documento.service';
import { ErrorMessagesService } from 'src/app/shared/messages/services/error-messages.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { cpfCnpjValidator } from 'src/app/shared/Utils/cpf-cnpj.validator';

@Component({
  selector: 'app-signatario',
  templateUrl: './signatario.component.html',
  styleUrl: './signatario.component.scss'
})
export class SignatarioComponent implements OnInit {
  @Input() documentoJaEnviadoParaAssinatura: StatusDocumentoAssinatura = {
    descricaoStatus: '',
    statusDocumentoAssinatura: 0,
    documentoUuId: '',
  };

  habilitarForm: boolean = true;

  settingService = false;
  signatarioForm!: FormGroup;
  projetoId = "";

  isLoading: boolean = false;

  error = "";
  erro403 = false;

  contratoId = "";

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private assinarDocumentoService: AssinarDocumentoService,
    private toastService: ToastService,
    private errorMessagesService: ErrorMessagesService
  ) {
    this.signatarioForm = this.fb.group({

      nomeAssinaturaPrincipal: ["", [Validators.required]],
      emailAssinaturaPrincipal: ["", [Validators.required]],
      documentoAssinaturaPrincipal: ["", [Validators.required, cpfCnpjValidator]],
      tipoAssinaturaPrincipal: [1, [Validators.required]],

      nomeAssinatura02:  ["", [Validators.required]],
      emailAssinatura02:  ["", [Validators.required]],
      documentoAssinatura02: ["", [Validators.required, cpfCnpjValidator]],
      tipoAssinatura02: [1, [Validators.required]],

      nomeAssinatura03: [null],
      emailAssinatura03: [null],
      documentoAssinatura03: [null],
      tipoAssinatura03: [null],

      nomeAssinatura04: [null],
      emailAssinatura04: [null],
      documentoAssinatura04: [null],
      tipoAssinatura04: [null],
    })
  }

  ngOnInit(): void {
    this.contratoId = this.route.snapshot.paramMap.get('id')!;

    if(this.documentoJaEnviadoParaAssinatura.statusDocumentoAssinatura == 0 || this.documentoJaEnviadoParaAssinatura?.statusDocumentoAssinatura == 2) {
      this.habilitarForm = false;
    }else{
      this.habilitarForm = true;
      this.signatarioForm.disable();
    }
    
    this.projetoId = this.route.snapshot.paramMap.get('id')!;
  }

  onSubmit() {
    this.isLoading = true;
    if (this.signatarioForm.invalid) {
      this.signatarioForm.markAllAsTouched();

      //Iterar sobre os campos e exibir os erros
      Object.keys(this.signatarioForm.controls).forEach((field) => {
        const control = this.signatarioForm.get(field);
        if (control?.errors) {
        }
      });

      this.isLoading = false;
      return;
    }

    // Construindo lista de signatários
    const signatarios: Signatario[] = [];
    const formValue = this.signatarioForm.value;

    // Adiciona signatario principal
    signatarios.push({
      nome: formValue.nomeAssinaturaPrincipal,
      email: formValue.emailAssinaturaPrincipal,
      cpf: formValue.documentoAssinaturaPrincipal,
      tipoAssinatura: formValue.tipoAssinaturaPrincipal
    })

    //verifica para adicionar segundo signatario
    if (formValue.nomeAssinatura02 && formValue.emailAssinatura02 && formValue.documentoAssinatura02) {
      signatarios.push({
        nome: formValue.nomeAssinatura02,
        email: formValue.emailAssinatura02,
        cpf: formValue.documentoAssinatura02,
        tipoAssinatura: formValue.tipoAssinatura02
      });
    }

    //verifica para adicionar terceiro signatario
    if (formValue.nomeAssinatura03 && formValue.emailAssinatura03 && formValue.documentoAssinatura03) {
      signatarios.push({
        nome: formValue.nomeAssinatura03,
        email: formValue.emailAssinatura03,
        cpf: formValue.documentoAssinatura03,
        tipoAssinatura: formValue.tipoAssinatura03
      });
    }

    //verifica para adicionar terceiro signatario
    if (formValue.nomeAssinatura04 && formValue.emailAssinatura04 && formValue.documentoAssinatura04) {
      signatarios.push({
        nome: formValue.nomeAssinatura04,
        email: formValue.emailAssinatura04,
        cpf: formValue.documentoAssinatura04,
        tipoAssinatura: formValue.tipoAssinatura04
      });
    }

    // // Agora cria o objeto AssinaturaDocumento
    // const assinaturaDocumento: AssinaturaDocumento = {
    //   documentoId: this.projetoId,
    //   signatarios: signatarios
    // };

    let adicionarSignatarios: AssinaturaDocumento = {
      documentoUuid: this.documentoJaEnviadoParaAssinatura.documentoUuId!,
      contratoId: this.contratoId,
      signatarios: signatarios
    };
    // Enviando via FormData
    // const formData = new FormData();
    // formData.append('DocumentoId', assinaturaDocumento.documentoId);
    // formData.append('SignatariosJson', JSON.stringify(assinaturaDocumento.signatarios));

    this.assinarDocumentoService.adcionarSignatarios(adicionarSignatarios).subscribe({
      next: () =>{
        this.toastService.show("Signatários adicionados com sucesso.", {
          classname: "bg-success text-light",
        });
        
        this.isLoading = false;

        setTimeout(() => {
          window.location.reload();
        }, 3000);
      },
      error: (err) =>{

        this.error = this.errorMessagesService.getMessage('ERR_0018');

        this.toastService.show("Erro ao tentar registrar signatários.", {
          classname: "bg-danger text-light",
        });

        this.isLoading = false;
      } 
    });
  }


  hasContratoDocumentContrato(): boolean {
    return false;
  }

  downloadDocument(documentName: string): void {

    // let url = this.documents.find(doc => doc.nomeArquivo == documentName);

    // const a = document.createElement('a');
    // a.href = url?.urlDownload!;
    // a.download = `${documentName}_template.docx`;
    // a.click();
    // window.URL.revokeObjectURL(url?.urlDownload!);
  }

  openModal(documentName: string, documentType: number): void {
    // this.modalExcluirComponent.payload = { documentName, documentType };
    // this.modalExcluirComponent.openModal();
  }





  // Manipula valores do checkbox do tipo de assinatura
  selecionarTipo3(valor: number) {
    const atual = this.signatarioForm.value.tipoAssinatura03;
    this.signatarioForm.patchValue({
      tipoAssinatura03: atual === valor ? null : valor
    });
  }

    // Manipula valores do checkbox do tipo de assinatura
    selecionarTipo4(valor: number) {
      const atual = this.signatarioForm.value.tipoAssinatura04;
      this.signatarioForm.patchValue({
        tipoAssinatura04: atual === valor ? null : valor
      });
    }

  isChecked3(valor: number): boolean {
    return this.signatarioForm.value.tipoAssinatura03 === valor;
  }

  isChecked4(valor: number): boolean {
    return this.signatarioForm.value.tipoAssinatura04 === valor;
  }

}
